import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/self-closing-comp */
/* eslint-disable max-len */

export const CalendarIcon = ({ className, width = 16, height = 16 }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 16 16"
      className={className}
      height={height}
      width={width}>
        <path d="M15,2h-2v-2h-2v2h-2v-2h-2v2h-2v-2h-2v2h-2c-0.553,0 -1,0.447 -1,1v12c0,0.553 0.447,1 1,1h14c0.553,0 1,-0.447 1,-1v-12c0,-0.553 -0.447,-1 -1,-1Zm-1,12h-12v-8h12v8Z" />
    </svg>
  );
}

CalendarIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export const DownArrow = () => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 16 16"
      height="16"
      width="16"
    ><path d="M8,11.4l-5.4,-5.4l1.4,-1.4l4,4l4,-4l1.4,1.4Z" />
    </svg>
  );
};

export const UpArrow = () => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 16 16"
      height="16"
      width="16"
    ><path d="M12,11.4l-4,-4l-4,4l-1.4,-1.4l5.4,-5.4l5.4,5.4Z" />
    </svg>
  );
};

export const RightArrow = ({ className, width = 16, height = 16 }) => {
  return (
   <svg 
      version="1.1"
      viewBox="0 0 16 16"
      className={className}
      height={height}
      width={width}
    ><path d="M5.108,16.41l-1.518,-1.302l6.093,-7.108l-6.093,-7.108l1.518,-1.302l6.651,7.76c0.321,0.374 0.321,0.927 0,1.301l-6.651,7.759Z"></path>
    </svg>
  );
}

RightArrow.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
 
export const LeftArrow = ({ className, width = 16, height = 16 }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 16 16"
      className={className}
      height={height}
      width={width}
    ><path d="M10.892,16.41l-6.651,-7.76c-0.321,-0.374 -0.321,-0.927 0,-1.301l6.651,-7.76l1.519,1.302l-6.094,7.109l6.093,7.108l-1.518,1.302Z"></path>
    </svg>
  );
}
LeftArrow.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export const MagnifyingGlass = () => {
  return (
    <svg version="1.1" viewBox="0 0 16 16">
      <g>
        <path d="M7,14c-3.86,0 -7,-3.14 -7,-7c0,-3.86 3.14,-7 7,-7c3.86,0 7,3.14 7,7c0,3.86 -3.14,7 -7,7Zm0,-12c-2.757,0 -5,2.243 -5,5c0,2.757 2.243,5 5,5c2.757,0 5,-2.243 5,-5c0,-2.757 -2.243,-5 -5,-5Z"></path>
        <path d="M15.707,14.293l-2.393,-2.393c-0.411,0.529 -0.885,1.003 -1.414,1.414l2.393,2.393c0.195,0.195 0.451,0.293 0.707,0.293c0.256,0 0.512,-0.098 0.707,-0.293c0.391,-0.391 0.391,-1.023 0,-1.414Z"></path>
      </g>
    </svg>
  );
};

export const ClockIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16px" height="16px">
      <path d="M 16 4 C 9.382813 4 4 9.382813 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 9.382813 22.617188 4 16 4 Z M 16 6 C 21.535156 6 26 10.464844 26 16 C 26 21.535156 21.535156 26 16 26 C 10.464844 26 6 21.535156 6 16 C 6 10.464844 10.464844 6 16 6 Z M 15 8 L 15 17 L 22 17 L 22 15 L 17 15 L 17 8 Z"/>
    </svg>
  );
};

export const BackButton = ({ className, style }) => {
  return (
    <svg version="1.1" viewBox="0 0 16 16" height="16" width="16" className={className} style={style}>
      <path d="M10,1h-8v2h8c1.7,0 3,1.3 3,3c0,1.7 -1.3,3 -3,3h-5.6l3,-3l-1.4,-1.4l-5.4,5.4l5.4,5.4l1.4,-1.4l-3,-3h5.6c2.8,0 5,-2.2 5,-5c0,-2.8 -2.2,-5 -5,-5Z">
      </path>
    </svg>
  );
};

BackButton.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export const InfoIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} width="12" height="12" viewBox="0 0 12 12">
      <path
        id="icon-16-info-outlined-a"
        d="M6,0 C2.7,0 0,2.7 0,6 C0,9.3 2.7,12 6,12 C9.3,12 12,9.3 12,6 C12,2.7 9.3,0 6,0 Z M6,10.5 C3.525,10.5 1.5,8.475 1.5,6 C1.5,3.525 3.525,1.5 6,1.5 C8.475,1.5 10.5,3.525 10.5,6 C10.5,8.475 8.475,10.5 6,10.5 Z M5.25,5.25 L6.75,5.25 L6.75,9 L5.25,9 L5.25,5.25 Z M6.5303325,3.2196675 C6.8232255,3.5125605 6.8232255,3.987435 6.5303325,4.280325 C6.2374395,4.573218 5.762565,4.573218 5.469675,4.280325 C5.176782,3.987432 5.176782,3.5125575 5.469675,3.2196675 C5.762568,2.9267745 6.2374425,2.9267745 6.5303325,3.2196675" />
      <use href="#icon-16-info-outlined-a"/>
    </svg>
  );
};

InfoIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export const AddButton = () => {
  return (
    <svg version="1.1" viewBox="0 0 16 16" height="16" width="16">
      <path d="M9,4h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"></path>
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg version="1.1" viewBox="0 0 16 16" height="16" width="16">
      <g fill="#AFC1E1">
        <path d="M5,7h2v6h-2Z" />
        <path d="M9,7h2v6h-2Z" />
        <path d="M12,1c0,-0.6 -0.4,-1 -1,-1h-6c-0.6,0 -1,0.4 -1,1v2h-4v2h1v10c0,0.6 0.4,1 1,1h12c0.6,0 1,-0.4 1,-1v-10h1v-2h-4v-2Zm-6,1h4v1h-4v-1Zm7,3v9h-10v-9h10Z" />
      </g>
    </svg>
  );
};

export const CheckmarkIcon = () => {
  return (
    <svg version="1.1" viewBox="0 0 16 16" height="16" width="16">
      <path
        d="M14.3,2.3l-9.3,9.3l-3.3,-3.3c-0.4,-0.4 -1,-0.4 -1.4,0c-0.4,0.4 -0.4,1 0,1.4l4,4c0.2,0.2 0.4,0.3 0.7,0.3c0.3,0 0.5,-0.1 0.7,-0.3l10,-10c0.4,-0.4 0.4,-1 0,-1.4c-0.4,-0.4 -1,-0.4 -1.4,4.44089e-16Z">
      </path>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg version="1.1" viewBox="0 0 16 16" height="16" width="16">
      <path
        d="M14.7,1.3c-0.4,-0.4 -1,-0.4 -1.4,0l-5.3,5.3l-5.3,-5.3c-0.4,-0.4 -1,-0.4 -1.4,2.22045e-16c-0.4,0.4 -0.4,1 0,1.4l5.3,5.3l-5.3,5.3c-0.4,0.4 -0.4,1 0,1.4c0.2,0.2 0.4,0.3 0.7,0.3c0.3,0 0.5,-0.1 0.7,-0.3l5.3,-5.3l5.3,5.3c0.2,0.2 0.5,0.3 0.7,0.3c0.2,0 0.5,-0.1 0.7,-0.3c0.4,-0.4 0.4,-1 0,-1.4l-5.3,-5.3l5.3,-5.3c0.4,-0.4 0.4,-1 0,-1.4Z">
      </path>
    </svg>
  );
}

export const CriticalAlertIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 488.451 488.451" width="512px" height="512px">
      <g>
        <path d="M484.125,412.013l-212.2-367.6c-12.3-21.3-43.1-21.3-55.4,0l-212.2,367.6c-12.3,21.3,3.1,48,27.7,48h424.4   C481.025,460.013,496.425,433.313,484.125,412.013z M244.525,157.613c13.6,0,24.6,11.3,24.2,24.9l-4,139.6   c-0.3,11-9.3,19.7-20.3,19.7s-20-8.8-20.3-19.7l-3.9-139.6C219.925,168.913,230.825,157.613,244.525,157.613z M244.225,410.113   c-13.9,0-25.2-11.3-25.2-25.2c0-13.9,11.3-25.2,25.2-25.2s25.2,11.3,25.2,25.2S258.125,410.113,244.225,410.113z" fill="#FFDA44" />
      </g>
    </svg>
  );
};

CriticalAlertIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export const OutageAlertIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 510 510">
      <g>
        <g id="error">
          <path d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M280.5,382.5h-51v-51h51V382.5z     M280.5,280.5h-51v-153h51V280.5z" fill="#D80027"/>
        </g>
      </g>
    </svg>
  );
};

export function PlusIconBold() {
  return (
    <svg version="1.1" viewBox="0 0 16 16" width="8" height="8">
          <path d="M10,0h-4v6h-6v4h6v6h4v-6h6v-4h-6Z" fill="#0ca0ef"></path>
    </svg>
  );
}

export function CrossIcon({ color }) {
  return (
    <svg width="9" height="9" viewBox="0 0 13 13">
      <g fill="none" stroke={color || '#105EEB'}>
        <path d="M12 11L1 0M12 0L1 11" />
      </g>
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-358.000000, -329.000000)" fill="#AFC1E1" fillRule="nonzero">
              <g transform="translate(90.000000, 290.000000)">
                  <g transform="translate(8.000000, 33.000000)">
                      <path d="M268,6 C263.6,6 260,9.6 260,14 C260,18.4 263.6,22 268,22 C272.4,22 276,18.4 276,14 C276,9.6 272.4,6 268,6 Z M271.5,16.1 L270.1,17.5 L268,15.4 L265.9,17.5 L264.5,16.1 L266.6,14 L264.5,11.9 L265.9,10.5 L268,12.6 L270.1,10.5 L271.5,11.9 L269.4,14 L271.5,16.1 Z"/>
                  </g>
              </g>
          </g>
      </g>
    </svg>
  );
}

export function GearIcon() {
  return (
    <svg width="14px" height="14px" viewBox="0 0 14 14">
      <title>icon-16-gear</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path d="M13.243125,5.936 C12.103,5.65075 11.56225,4.34525 12.166875,3.338125 C12.448625,2.869125 12.36375,2.464875 12.084625,2.186625 L11.813375,1.915375 C11.535125,1.637125 11.130875,1.55225 10.661875,1.833125 C9.653875,2.43775 8.348375,1.897 8.064,0.756875 C7.931875,0.22575 7.585375,0 7.191625,0 L6.808375,0 C6.414625,0 6.069,0.22575 5.936,0.756875 C5.65075,1.897 4.34525,2.43775 3.338125,1.833125 C2.869125,1.551375 2.464,1.63625 2.18575,1.9145 L1.9145,2.18575 C1.63625,2.464 1.551375,2.869125 1.833125,3.338125 C2.43775,4.346125 1.897,5.651625 0.756875,5.936 C0.2275,6.068125 0,6.41375 0,6.808375 L0,7.191625 C0,7.585375 0.22575,7.931 0.756875,8.064 C1.897,8.34925 2.43775,9.65475 1.833125,10.661875 C1.551375,11.130875 1.63625,11.535125 1.915375,11.813375 L2.186625,12.084625 C2.46575,12.36375 2.870875,12.44775 3.338125,12.166875 C4.346125,11.56225 5.651625,12.103 5.936,13.243125 C6.068125,13.77425 6.414625,14 6.808375,14 L7.191625,14 C7.585375,14 7.931,13.77425 8.064,13.243125 C8.34925,12.103 9.65475,11.56225 10.661875,12.166875 C11.13,12.44775 11.53425,12.36375 11.813375,12.084625 L12.084625,11.813375 C12.362875,11.535125 12.44775,11.130875 12.166875,10.661875 C11.56225,9.653875 12.103,8.348375 13.243125,8.064 C13.77425,7.931875 14,7.585375 14,7.191625 L14,6.808375 C14,6.41375 13.7725,6.068125 13.243125,5.936 Z M7,9.625 C5.550125,9.625 4.375,8.449875 4.375,7 C4.375,5.550125 5.550125,4.375 7,4.375 C8.449875,4.375 9.625,5.550125 9.625,7 C9.625,8.449875 8.449875,9.625 7,9.625 Z" id="icon-16-gear" fill="#AFC1E1" fillRule="nonzero"></path>
      </g>
    </svg>
  );
}

export function AddIcon() {
  return (
    <svg width="13" height="11" viewBox="0 0 13 11">
      <g transform="translate(6, 1) rotate(-315.000000)" strokeWidth="2" fill="none" stroke="currentColor">
        <path d="M6.51920241,0 L0,6.51920241"></path>
        <path d="M0,0 L6.51920241,6.51920241"></path>
      </g>
    </svg>
  );
}

OutageAlertIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export const ShareIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
      <path fill="inherit" d="M15,0H8v2h4.6L6.3,8.3l1.4,1.4L14,3.4V8h2V1C16,0.4,15.6,0,15,0z" />
      <path fill="inherit" d="M14,16H1c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1h4v2H2v11h11v-3h2v4C15,15.6,14.6,16,14,16z" />
    </svg>
  );
};

ShareIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export const PencilIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
      <path fill="inherit" d="M11.7,0.3c-0.4-0.4-1-0.4-1.4,0l-10,10C0.1,10.5,0,10.7,0,11v4c0,0.6,0.4,1,1,1h4c0.3,0,0.5-0.1,0.7-0.3 l10-10c0.4-0.4,0.4-1,0-1.4L11.7,0.3z M4.6,14H2v-2.6l6-6L10.6,8L4.6,14z M12,6.6L9.4,4L11,2.4L13.6,5L12,6.6z" />
    </svg>
  )
};

PencilIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export const IntegrationBridgIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="128px" height="128px" viewBox="0 0 128 128">
      <path fill="inherit" d="M7.91971922,15.4630428 L17.3477976,15.4630428 C19.3654488,15.4630428 20.844883,15.1160716 21.7701921,14.4035887 C22.6955013,13.6911058 23.1700868,12.6263544 23.1700868,11.1484159 C23.1700868,9.67047743 22.7034552,8.5871856 21.7701921,7.89324316 C20.9960079,7.26816523 19.484758,6.96092354 17.2284884,6.96092354 L7.91971922,6.96092354 L7.91971922,15.4630428 Z M3.82883176e-05,4.1878024 C-0.00472796254,3.07523687 0.435668894,2.00684356 1.22342442,1.22038187 C2.01117994,0.433920178 3.08093269,-0.00535581324 4.19462075,4.92963365e-05 L18.8696528,4.92963365e-05 C22.9827271,4.92963365e-05 26.1254199,0.854053465 28.2977312,2.56154034 C30.4665074,4.41558504 31.5508955,6.93620294 31.5508955,10.1233941 C31.5508955,12.1381226 31.1240337,13.842078 30.2703101,15.2352601 C29.376883,16.5896088 28.1313252,17.6755088 26.6671721,18.3765416 C27.3707098,18.6673732 28.046085,19.0220078 28.6848233,19.4359957 C27.5341523,22.0025233 26.2827313,25.2629933 24.331363,27.3315775 C24.2915933,25.5834782 23.7454223,24.2935928 22.7034552,23.4725159 C21.6906526,22.6991144 19.9911593,22.309765 17.5758108,22.309765 L7.91971922,22.309765 L7.91971922,32.7718743 L17.6977713,32.7718743 C17.8754094,32.7718743 18.047745,32.7718743 18.2280344,32.7718743 C19.4610154,32.7446465 20.6850051,32.5549551 21.8682908,32.207715 L21.9743434,32.1759314 C26.9694221,30.5867502 29.0480535,25.8377472 30.9729087,21.4966339 C32.3462902,18.3765416 33.772698,15.2246656 36.2437242,12.9627311 L36.4611321,12.7667321 L36.519461,12.7137594 C36.6272812,12.62194 36.7359851,12.5336522 36.8455728,12.4488958 L37.0868426,12.2634914 L37.1027505,12.2634914 L37.3228096,12.1019246 L37.3784873,12.0621951 L37.5349149,11.953601 C40.66877,9.79231465 44.6722566,8.95004863 48.4848485,9.43474889 L48.4848485,17.581951 C47.7973754,17.4184584 47.0942305,17.3296551 46.3876578,17.3170875 C42.4106844,17.3886006 39.971474,19.891561 39.971474,24.0605129 L39.971474,39.9920541 L31.8398889,39.9920541 L31.8398889,34.2471642 C30.8844144,35.4491329 29.7485989,36.4962431 28.472718,37.3513647 C26.0299726,39.0765092 22.74676,39.9593876 18.6230805,40 L3.82883176e-05,40 L3.82883176e-05,4.1878024 Z" />
    </svg>
  )
};

export const IntegrationFacebookIcon = ({ className, style }) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="128px" height="128px" viewBox="0 0 128 128">
      <path fill="inherit" d="M56,28.1700238 C56,12.6109222 43.4632498,-0.00220095506 27.9983593,-0.00220095506 C12.5334688,-0.00220095506 -0.00328144227,12.6109222 -0.00328144227,28.1700238 C-0.00328144227,42.2315955 10.2365139,53.8865329 23.6231029,56 L23.6231029,36.3135575 L16.5133113,36.3135575 L16.5133113,28.1700238 L23.6231029,28.1700238 L23.6231029,21.9633305 C23.6231029,14.9026667 27.803551,11.0025743 34.1997383,11.0025743 C37.2633475,11.0025743 40.4678399,11.5528131 40.4678399,11.5528131 L40.4678399,18.4858215 L36.9368986,18.4858215 C33.4584058,18.4858215 32.3736156,20.6574489 32.3736156,22.8853656 L32.3736156,28.1700238 L40.1396957,28.1700238 L38.8982167,36.3135575 L32.3736156,36.3135575 L32.3736156,56 C45.7602047,53.8865329 56,42.2315955 56,28.1700238" />
    </svg>
  )
};
